import React, { Fragment } from 'react';
import { Breadcrumbs } from '../../AbstractElements';
import DataTablesContain from '../../Component/Tables/DataTable8';
import { useTranslation } from 'react-i18next';

const DataTable6 = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs parent={t("Dashboard")} title={t("Payment Due")} />
      <DataTablesContain />
    </Fragment>
  );
};
export default DataTable6;
